/** @format */

import React, {useEffect, useState} from 'react';
import SuperAgent from 'superagent';

const AccountContext = React.createContext();

const AccountContextProvider = props => {
    const [user, setUser] = useState({});

    const fetchUserData = async () => {
        const response = await SuperAgent.get('/account/users/current-user').set(
            'accept',
            'application/json'
        );

        setUser(response.body.user);
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    return <AccountContext.Provider value={{user}}>{props.children}</AccountContext.Provider>;
};

const useAccountContext = () => {
    const context = React.useContext(AccountContext);
    if (context === undefined) {
        throw new Error('useAccountContext must be used within a AccountContextProvider');
    }
    return context;
};

export {AccountContextProvider, useAccountContext, AccountContext};
